// ------ Sticky Footer ------
function sticky_footer() {
  var header_height = $(".js-header").outerHeight(),
    content_height = $(".js-main-container").outerHeight(),
    footer_height = $(".js-footer").outerHeight(),
    offset =
      $(window).height() - header_height - content_height - footer_height;

  if (offset > 0) {
    // Adding padding on .js-main-container (original sticky-footer.js .js-footer + margin-top)
    $(".js-main-container").css("padding-bottom", offset);
  }
}

$(window).on("load", function () {
  sticky_footer();

  $(window).on("resize orientationchange", function () {
    setTimeout(sticky_footer(), 200);
  });
});

// ------ Sticky Sidebar ------
var $sidebarHeight = $(".m-sidebar").height();
var $windowHeight = $(window).height();

// Remove sticky when the sidebar is longer than window view height
if ($sidebarHeight > $windowHeight) {
  $(".m-sidebar__sticky-container").removeAttr("data-sticky");
}
